import React from 'react';
import loadable from '@loadable/component';

export default {
	component: loadable(
		() => import(/* webpackChunkName: "discount" */ './AddEditDiscount'),
		{
			fallback: <div>Loading...</div>
		}
	)
};